// extracted by mini-css-extract-plugin
export var actionButton = "_92-1";
export var actionButtons = "_92-2";
export var actions = "_92-0";
export var aiUnread = "_92-10";
export var alignCenter = "_92-h";
export var backWrapper = "_92-3";
export var cellContainer = "_92-4";
export var checkboxContainer = "_92-5";
export var contentContainer = "_92-6";
export var contentHeader = "_92-8";
export var conversationsTableWrapper = "_92-s";
export var draftReplyBadgeContainer = "_92-m";
export var dropdownItem = "_92-b";
export var dropdownItemsContainer = "_92-a";
export var dropdownTitle = "_92-c";
export var errorIcon = "_92-7";
export var filter = "_92-d";
export var gray = "_92-i";
export var headerActionButtons = "_92-e";
export var headerCheckboxContainer = "_92-f";
export var icon = "_92-j";
export var menuContainer = "_92-k";
export var noMoreTicketsIcon = "_92-12";
export var noMoreTicketsSubText = "_92-13";
export var oneLine = "_92-l";
export var optionsButton = "_92-n";
export var plus = "_92-o";
export var portalButtonsWrapper = "_92-g";
export var red = "_92-p";
export var scrolledTop = "_92-9";
export var search = "_92-q";
export var selectedConversationsCount = "_92-r";
export var spinner = "_92-t";
export var strong = "_92-u";
export var summaryCell = "_92-v";
export var tableContainer = "_92-11";
export var tagContainer = "_92-w";
export var threeDots = "_92-x";
export var twoLines = "_92-y";
export var unread = "_92-z";